import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLnc = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M750 630q-2-1-3 1l-64 63q-3 3-6.5 3.5t-5-1 4.5-7.5l59-59q1-1 1-3-15-4-29-9-26-10-45-30-1-1-3 1l-21 21q-2 2-6 2.5t-5.5-1 3.5-6.5l23-23q2-1 1-2-7-9-11-17l-3-7-76-54q-84-61-125-97L201 193v-13l-67-53q-3-2-6-2l-2 1-1 2q0 3 2 6l53 67h13l212 238q36 41 97 125l54 76 11 5q13 8 25 20 16 17 26 42 14 34 14 84 0 8 1 9 3 3 8-1l52-53q6-5 10 0l9 9q3 3 15 2l10-2 64 63q-2 9 0 17 1 5 6 12-1 4 2 6.5t12 1.5l7-1q12-2 15 1 11 9 23 18 5 3 8 2l1-3q0-2-2-5-9-13-18-24-3-3-1-15l1-7q1-9-1.5-11.5T846 807l-27 28-1-2q0-3 1.5-7t6.5-9l10-10q2-2 1.5-4t-2.5-2q-9-2-17 0l-63-64 1-10q2-11-1-14l-7-7q-1-1-3 1l-14 14q-5 5-10 6t-6 0 2-5l81-81q5-4 1-8 0-1-9-1-23 0-40-2z" })
});
export default SvgLnc;
